import { useEffect, useState } from 'react';

/**
 * Whether a CSS media query matches, kept current as the viewport changes. Used where the layout must mount ONE of two
 * trees (WEB-111: the desktop top bar or the phone header, never both, so a stateful control like the Platform admin
 * chip is never mounted twice). Without matchMedia it reads false.
 */
export function useMediaQuery(query: string): boolean {
    const read = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false);
    const [matches, setMatches] = useState(read);
    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
        const mql = window.matchMedia(query);
        const onChange = () => setMatches(mql.matches);
        onChange();
        mql.addEventListener?.('change', onChange);
        return () => mql.removeEventListener?.('change', onChange);
    }, [query]);
    return matches;
}

/** The md breakpoint (Tailwind's 768 px): the top bar at and above it, the drawer below. */
export const DESKTOP_SHELL_QUERY = '(min-width: 768px)';
